export const primary = {
  main: '#2C5CCB',
  20: '#2C5CCB',
  light: '#9CB9FC',
  10: '#9CB9FC',
  dark: '#0F42A1',
  30: '#0F42A1',
  0: '#BFD3FF',
  50: '#19377B',
  70: '#0E2761',
  90: '#041846',
  contrastText: '#fff'
};

export const secondary = {
  main: '#68C733',
  30: '#68C733',
  light: '#A3D572',
  10: '#A3D572',
  dark: '#629435',
  50: '#629435',
  5: '#AEEA73',
  70: '#386A07',
  90: '#0E4300'
};

export const neutral = {
  main: '#707888',
  30: '#707888',
  light: '#949DAF',
  20: '#949DAF',
  dark: '#4D5362',
  50: '#4D5362',
  '000': '#ECEEF1',
  '00': '#E5EBF4',
  0: '#CFDAEC',
  5: '#C1CCE7',
  10: '#B4BED7',
  80: '#2F3442',
  90: '#171C28',
  contrastText: '#fff'
};

export const error = {
  main: '#FF5F5F',
  30: '#FF5F5F',
  light: '#FF928C',
  20: '#FF928C',
  dark: '#D3353E',
  60: '#D3353E',
  10: '#FFCBCB',
  80: '#A1001C',
  90: '#88000A'
};

export const hover = {
  primary: '#ECEEF1',
  secondary: '#F4F5F8'
};

export const success = {
  80: '#005B1C',
  60: '#008441',
  dark: '#008441',
  30: '#05944F',
  main: '#05944F',
  20: '#69DD91',
  light: '#69DD91',
  10: '#BCF1CF',
  90: '#004709'
};

export const warning = {
  90: '#792E0D',
  80: '#93370D',
  70: '#E65100',
  60: '#DC6803',
  dark: '#DC6803',
  30: '#FEC84B',
  main: '#FEC84B',
  20: '#FEDF89',
  light: '#FEDF89',
  10: '#FEEFC7',
  5: '#FFF3E2'
};

export const text = {
  primary: '#171C28',
  secondary: '#2F3442',
  disabled: '#707888'
};

export const background = {
  '00': '#FFFFFF',
  5: '#F0F2F5',
  10: '#DDDDDD',
  20: '#C6C6C6'
};

export const disabled = {
  60: '#4D5362',
  dark: '#4D5362',
  30: '#707888',
  main: '#707888',
  20: '#949DAF',
  light: '#949DAF',
  10: '#B6BECE',
  5: '#CCD2DE'
};
